// src/hooks/useIsMobile.ts (Conceptual - you'd implement this with window.matchMedia)
import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768; // Example breakpoint

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};